


























































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import AbpConst from "@/lib/appconst";
import ListMixin from "@/components/mixin/list-mixin";
import { mixins } from "vue-class-component";
import PageRequest from "@/store/entities/page-request";
import AppConsts from "@/lib/appconst";
import InventoryReportDetailInput from "@/store/entities/inventoryReportDetailInput";
class PageInventoryReportDetailRequest extends PageRequest {
  warehouseCode: string;
  type: string;
  pageSize: number;
  pageNumber: number;
  assetTypeCode: string;
  conditionTypeCode: string;
  productId: number;
}

@Component
//.ivu-form-label-left .ivu-form-item-label
export default class InventoryReportDetailModal extends mixins(
  ListMixin,
  AbpBase
) {
  @Prop({ type: Boolean, default: false }) value: boolean;
  @Prop({
    type: InventoryReportDetailInput,
    default: new InventoryReportDetailInput(),
  })
  objectSelected: InventoryReportDetailInput;
  namespace = "inventoryReportDetail";
  pagerequest: PageInventoryReportDetailRequest = new PageInventoryReportDetailRequest();
  get store() {
    return this.$store.state.inventoryReportDetail;
  }
  cancel() {
    (this.$refs.form as any).resetFields();
    this.$emit("input", false);
  }
  async visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    } else {
      this.pagerequest.warehouseCode = this.objectSelected.warehouseCode;
      this.pagerequest.type = this.objectSelected.type;
      this.pagerequest.pageNumber = 0;
      this.pagerequest.assetTypeCode = this.objectSelected.assetTypeCode;
      this.pagerequest.conditionTypeCode = this.objectSelected.conditionTypeCode;
      this.pagerequest.productId = this.objectSelected.productId;
      await this.getpage();
    }
  }
  async getpage() {
    this.pagerequest.pageSize = this.pageSize;
    this.pagerequest.pageNumber = this.currentPage;
    await this.$store.dispatch({
      type: `${this.namespace}/getAll`,
      data: this.pagerequest,
    });
  }
  getObjectRoute(id: number, code: string) {
    if (
      this.pagerequest.type ===
        AppConsts.inventoryReportDetailType.waitingInTO ||
      this.pagerequest.type === AppConsts.inventoryReportDetailType.waitingInPO
    ) {
      return "/operations/view/purchaseorder/" + code;
    }
    return "/operations/view/saleorder-request/" + id;
  }
  columns = [
    {
      title: Util.L("Code"),
      width: 150,
      slot: "objectCode",
    },
    {
      title: this.L("Qty"),
      key: "qty",
      width: 100,
      align: "right",
      render: (h: any, params: any) => {
        return h("span", Util.toViewNumberString(params.row.qty));
      },
    },
    {
      title: this.L("Status"),
      key: "statusName",
    },
    {
      title: Util.L("CreationTime"),
      key: "creationTime",
      render: (h: any, params: any) => {
        return h("span", Util.toViewDateString(params.row.creationTime));
      },
    },
    {
      title: Util.L("Customer"),
      key: "customerName",
    },
  ];
}
